/** Shared pay-period helpers — keep Commissions reports and Staff Payouts in sync. */

export const monthStart = (ym) => `${ym}-01`;

export const monthEnd = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return `${ym}-${String(last).padStart(2, "0")}`;
};

export const currentMonth = () => new Date().toISOString().slice(0, 7);

export const monthOptions = (count = 12) => {
  const out = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    out.push(d.toISOString().slice(0, 7));
  }
  return out;
};
